export const AW_SF_RECOMMENDATION = 'awSfmcRecommendation';
